export const configuratorKeys = {
    root: ['configurator'] as const,
    /** Prefix covering every configurator query for a unit (current state + style previews). */
    byUnit: (residentialUnitId: number) => ['configurator', residentialUnitId] as const,
    byUnitAndDeadline: (residentialUnitId: number, deadlineId: number | null) =>
        ['configurator', residentialUnitId, deadlineId] as const,
    allDeadlinesByUnit: (residentialUnitId: number) => ['configurator', residentialUnitId, 'all-deadlines'] as const,
    /** As-if-applied snapshot for one style; baseline is the current state, so it shares the byUnit prefix. */
    stylePreview: (residentialUnitId: number, styleId: number, roomId: number | null) =>
        ['configurator', residentialUnitId, 'style-preview', styleId, roomId] as const,
};
